<div class="container-md p-md-0 mb-5">
  <div class="row g-3">
    <div class="col col-12">
      <ts-asset-selection
        header="{{ 'my_eligible_lines' | translate }}"
        no_asset_text="{{ 'no_eligible_lines' | translate }}"
        [asset_fields]="['plan', 'contract_end_date', 'add_on_features']"
        [existing_asset]="
          shopping_cart && shopping_cart.existing_asset?.asset_from_inventory
            ? shopping_cart.existing_asset
            : undefined
        "
        (asset_selection_emit)="selectAsset($event)"
      >
        <ng-template>
          <div class="row">
            <div class="col col-12">
              <hr />
              <button
                class="d-flex justify-content-center align-items-center btn btn-outline-secondary w-100"
                (click)="selectAsset(undefined)"
                [disabled]="userAssetLoading"
              >
                {{ 'no_company_device' | translate }}
                <span
                  *ngIf="
                    shopping_cart &&
                    shopping_cart.existing_asset &&
                    !shopping_cart.existing_asset.asset_from_inventory
                  "
                  ngbTooltip="{{ 'selected_item' | translate }}"
                  class="material-icons text-primary fs-5 ps-1"
                >
                  check_circle
                </span>
              </button>
            </div>
          </div>
        </ng-template>
      </ts-asset-selection>
    </div>
  </div>
</div>
